module.exports = __webpack_public_path__ + "static/media/services-bg-1.a58bd04a.svg";